import _ from 'lodash'
import { useCallback, useEffect, useState } from 'react'

import { Text } from '../../components/Text'
import { Button } from '../../components/Button'
import { Image } from '../Image'
import { Box } from '../Box'
import { ThemeWrapper } from '../theme'

import { ContactUsLink, TitleWrapper, StickyWrapper, ScaledImage } from './styled'

export type ContactWidgetProps = {
  contactWidget: {
    id: string
    title: string
    description: string
    link?: {
      url: string
      text: string
      target?: string
    }
    textColor: string
    image?: {
      url: string
      alt?: string
    }
    backgroundColor?: string
    icon?: string
  }
  anchor: boolean
}

export const ContactWidget = ({ contactWidget, anchor }: ContactWidgetProps) => {
  const [isExpanded, setIsExpanded] = useState(false)
  const showFullWidget = () => setIsExpanded(!isExpanded)
  const collapseCallback = useCallback(() => setIsExpanded(false), [])

  useEffect(() => {
    const events = ['scroll', 'resize']
    _.forEach(events, event => window.addEventListener(event, collapseCallback))
    return () => {
      _.forEach(events, event => window.removeEventListener(event, collapseCallback))
    }
  }, [collapseCallback])

  return (
    <ThemeWrapper>
      <StickyWrapper
        backgroundColor={contactWidget?.backgroundColor}
        textColor={contactWidget?.textColor}
        anchor={anchor}
        horizontalAlignment={_.includes(contactWidget?.icon, 'right') ? 'right' : 'left'}
        verticalAlignment={_.includes(contactWidget?.icon, 'top') ? 'top' : 'bottom'}
      >
        {isExpanded && (
          <>
            <TitleWrapper width={1} alignItems="center" pt={1} onClick={showFullWidget}>
              <Image
                type={_.includes(contactWidget?.icon, 'top') ? 'arrowUpWhite' : 'down'}
                alt={_.includes(contactWidget?.icon, 'top') ? 'up' : 'down'}
              />
              <Text bold>{contactWidget?.title}</Text>
            </TitleWrapper>
            <Box p={1} className="rich-text-content" dangerouslySetInnerHTML={{ __html: contactWidget.description }} />
            {contactWidget?.link?.url && (
              <ContactUsLink href={contactWidget?.link?.url}>
                <Button
                  ml={1}
                  iconPlacement="left"
                  icon={
                    contactWidget?.image?.url ? (
                      <ScaledImage src={contactWidget?.image?.url} alt={contactWidget?.image?.alt} />
                    ) : undefined
                  }
                >
                  {contactWidget?.link?.text}
                </Button>
              </ContactUsLink>
            )}
          </>
        )}
        {!isExpanded && (
          <TitleWrapper width={1} alignItems="center" pt={1} onClick={showFullWidget}>
            <Image
              type={_.includes(contactWidget?.icon, 'top') ? 'down' : 'arrowUpWhite'}
              alt={_.includes(contactWidget?.icon, 'top') ? 'down' : 'up'}
            />
            <Text bold>{contactWidget?.title}</Text>
          </TitleWrapper>
        )}
      </StickyWrapper>
    </ThemeWrapper>
  )
}
